import React from "react";

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export const useStableEffect = (callback: Function, deps: unknown[]) => {
  const shouldBypassDevFirstFakeMountUnmountRef = React.useRef(
    process.env.NODE_ENV === "development",
  );

  React.useEffect(() => {
    if (shouldBypassDevFirstFakeMountUnmountRef.current) {
      shouldBypassDevFirstFakeMountUnmountRef.current = false;
      return;
    }
    return callback();
  }, deps);
};

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export const useEffectOnChangeOnly = (callback: Function, deps: unknown[]): void => {
  const shouldBypassDevFirstFakeMountUnmountRef = React.useRef(
    process.env.NODE_ENV === "development",
  );

  const didRealMount = React.useRef(false);

  React.useEffect(() => {
    if (shouldBypassDevFirstFakeMountUnmountRef.current) {
      shouldBypassDevFirstFakeMountUnmountRef.current = false;
      return;
    }
    if (!didRealMount.current) {
      didRealMount.current = true;
      return;
    }
    return callback();
  }, deps);
};
